export const parseAndSplitHtmlText = (input: string) =>
  input
    .replace(/&quot;|&amp;quot;/g, '"')
    .split('<br />')
    .filter((line) => line.trim() !== '');
